import { render, staticRenderFns } from "./task-view-detail.vue?vue&type=template&id=de54b438"
import script from "./task-view-detail.vue?vue&type=script&lang=js"
export * from "./task-view-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports